export const planCounterQueryKeys = {
  PLAN_COUNTER: 'planCounter'
}
